var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUsdt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1887_3281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C18.6271 0 24 5.37288 24 12C24 18.6271 18.6269 24 12 24C5.37312 24 0 18.6286 0 12C0 5.37144 5.37216 0 12 0Z",
    fill: "#53AE94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4806 10.4011V8.61601H17.5628V5.89609H6.44696V8.61601H10.5296V10.3997C7.2116 10.5521 4.7168 11.2092 4.7168 11.9964C4.7168 12.7836 7.2128 13.4407 10.5296 13.5941V19.3121H13.4816V13.5936C16.7936 13.4407 19.2834 12.7841 19.2834 11.9976C19.2834 11.2111 16.7936 10.5545 13.4816 10.4016M13.4816 13.1093V13.1078C13.3983 13.1131 12.9704 13.1388 12.0176 13.1388C11.2558 13.1388 10.7199 13.1172 10.531 13.1074V13.1098C7.59968 12.9799 5.4116 12.4694 5.4116 11.8586C5.4116 11.2478 7.59992 10.7381 10.531 10.608V12.6012C10.723 12.6144 11.2722 12.6468 12.0301 12.6468C12.9404 12.6468 13.3981 12.6089 13.4821 12.6012V10.608C16.4077 10.7383 18.5907 11.2493 18.5907 11.8579C18.5907 12.4666 16.4067 12.9778 13.4821 13.1081",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1887_3281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

export default __webpack_public_path__ + "media/4c530cc8.svg";
export { SvgUsdt as ReactComponent };